<template>
  <div id="participants" >
    <div class="container">
      <ParticipantsComponent />
    </div>
  </div>
</template>

<script>
import ParticipantsComponent from "../modules/Participants.vue";
import $ from "jquery"

export default {
  name: "Participants",
  components: {
    ParticipantsComponent
  },
    mounted() {
      $("html, body").animate({ scrollTop: 0 }, 350);
  },
  computed: {
    
  }
};
</script>

<style lang="less">
#participants {
  background-color: #F1F3F6;
  min-height: calc(~"100vh");
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0px 20px;

  .container {
    display: block;
    max-width: 1120px;
    width: inherit;
    margin: 0 auto;
    margin-bottom: 40px;
  }
}

@media (max-width: 768px) {
  #participants {
    padding: 0px;
    padding-bottom: 60px;
    .container {
      padding: 0px 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Participants.vue